import { ReactElement, CSSProperties, memo } from 'react'
import { animated } from 'react-spring'

import { useAnimations } from './methods'
import Container from './style'

interface Props {
  className?: string
  id?: string
  style?: CSSProperties
  isClicked?: boolean
  onClick?: () => void
  onMouseDown?: () => void
  onMouseUp?: () => void
}

function Hamburger({
  id,
  className,
  style,
  isClicked,
  onClick,
  onMouseDown,
  onMouseUp,
}: Props): ReactElement {
  const {
    handleMouseEnter,
    handleMouseLeave,
    topBarSpring,
    middleBarSpring,
    bottomBarSpring,
  } = useAnimations(isClicked as boolean)

  return (
    <Container
      id={id}
      className={className}
      style={{
        ...style,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      aria-label="menu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="24"
        viewBox="-3 -3 30 24"
      >
        <g fill="currentColor">
          <animated.rect
            style={topBarSpring}
            width="24"
            height="2"
            x="0"
            y="0"
            rx="1"
          />
          <animated.rect
            style={middleBarSpring}
            width="16"
            height="2"
            x="8"
            y="8"
            rx="1"
          />
          <animated.rect
            style={bottomBarSpring}
            width="24"
            height="2"
            y="16"
            rx="1"
          />
        </g>
      </svg>
    </Container>
  )
}

Hamburger.defaultProps = {
  className: '',
  isClicked: false,
}

export default memo(Hamburger)
